var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgWarning = function SvgWarning(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Warning' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0000923,0 L9.23076923e-05,42 L48.0000923,42 L24.0000923,0 Z M24.0000923,3.76226667 L44.8191692,40.1333333 L3.18101538,40.1333333 L24.0000923,3.76226667 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.3846154 15.8666667 22.6153846 15.8666667 23.0769231 28.9333333 24.9230769 28.9333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,31.7246533 C22.98,31.7246533 22.1538462,32.56092 22.1538462,33.59132 C22.1538462,34.62172 22.98,35.4579867 24,35.4579867 C25.02,35.4579867 25.8461538,34.62172 25.8461538,33.59132 C25.8461538,32.56092 25.02,31.7246533 24,31.7246533"
  })));
};
SvgWarning = pure(SvgWarning);
SvgWarning.displayName = 'SvgWarning';
export default SvgWarning;